import React, {useEffect, useState} from "react";
import {StyledItemPreviewModal} from "./ItemPreviewModal.style";
import nuggets from "../../../../assets/nuggets.png";
import Button from "components/molecules/Button";
import menuStoreService from "services/menu-storeService";
import Toast from "components/molecules/Toast";
import {useAuthContext} from "Context/authContext";

const ItemPreviewModal = ({isEdit, payload, item}) => {
    const {refetch} = useAuthContext();
    const [previewImage, setPreviewImage] = useState(null);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        // Check for verticalImage first, then horizontalImage as fallback
        const verticalFile = payload.get("verticalImage");
        const horizontalFile = payload.get("horizontalImage");
        
        const imageFile = verticalFile || horizontalFile;
        
        if (imageFile) {
            const objectUrl = URL.createObjectURL(imageFile);
            setPreviewImage(objectUrl);

            // cleanup to avoid memory leaks
            return () => URL.revokeObjectURL(objectUrl);
        }
    }, [payload]);

    const handleSubmit = async () => {
        try {
            setLoader(true);
            let res;
            if (!isEdit) {
                res = await menuStoreService.createItem(payload);
            } else {
                res = await menuStoreService.updateItem(payload, item?._id);
            }

            Toast({type: "success", message: res?.message});
            refetch();
            setLoader(false);
        } catch (error) {
            Toast({type: "error", message: "Failed"});
            setLoader(false);
        }
    };
    return (
        <StyledItemPreviewModal>
            <img src={previewImage ?? nuggets} alt="nuggets" className="img" />

            <div className="title-wrap">
                <strong className="title">{payload.get("name") ?? "Hash Brown"}</strong>
                <div className="status-wrap">
                    <div className="success-dot"></div>
                    <span className="status">Available</span>
                </div>
            </div>

            <span className="desc">{payload.get("description")}</span>

            <div className="row">
                <span className="tag">Popular</span>
                <span className="calories">{payload.get("calories")} Cal</span>
            </div>

            <div className="row">
                <span className="price">${payload.get("price")}</span>
                {payload.get("discountPrice") && parseFloat(payload.get("discountPrice")) > 0 && (
                    <del className="discount-price">${payload.get("discountPrice")}</del>
                )}
            </div>

            <div className="separator"></div>

            <div className="btn-holder">
                {/* <Button variant="secondary" className="btn">
                    Edit Item
                </Button> */}
                <Button className="btn" onClick={() => handleSubmit()} loader={loader}>
                    Save & Publish
                </Button>
            </div>
        </StyledItemPreviewModal>
    );
};

export default ItemPreviewModal;
